// extracted by mini-css-extract-plugin
export var attachmentContainer = "_ly-0";
export var fileList = "_ly-2";
export var removeFileButton = "_ly-1";